<template>
    <div style="position: relative;">
        <div class="weeklist df">
            <span class="f1 harmonyos-text" @click="handleWeek(index)" v-for="(item, index) in weeklist"
                :class="{ 'active': index == dayData }">
                {{ item.day }}
                {{ $t(item.week) }}
            </span>
        </div>

        <div class="line-box pt-16" ref="scrollableDiv" @scroll="handleScroll">
            <div class="drag-left fn df fdc" style="">
                <div v-for="item1 in day1" class="drag-lefttext">
                    <span class="harmonyos-text">{{ item1 }}</span>
                </div>
                <div v-for="item1 in day1" class="drag-lefttext">
                    <span class="harmonyos-text">{{ item1 }}</span>
                </div>
                <div v-for="item1 in day1" class="drag-lefttext">
                    <span class="harmonyos-text">{{ item1 }}</span>
                </div>
                <div v-for="item1 in day1" class="drag-lefttext">
                    <span class="harmonyos-text">{{ item1 }}</span>
                </div>
                <div v-for="item1 in day1" class="drag-lefttext">
                    <span class="harmonyos-text">{{ item1 }}</span>
                </div>
                <div v-for="item1 in day1" class="drag-lefttext">
                    <span class="harmonyos-text">{{ item1 }}</span>
                </div>
                <div v-for="item1 in day1" class="drag-lefttext">
                    <span class="harmonyos-text">{{ item1 }}</span>
                </div>
            </div>


            <div class="drag-container" v-drag ref="drag_container">

                <table style="width: 100%;">

                    <tbody>

                        <template v-for="item in weeklist">

                            <tr class="scroll-container" v-for="itemday in day1">
                                <span style="position: absolute;z-index: -1000;opacity: 0;">{{ data[item.day].length
                                    }}</span>
                                <template v-if="data[item.day].length">

                                    <template v-if="getselect(data[item.day], itemday).length > 0">
                                        <td class="item-box "
                                            :style="{ minWidth: minWidth, paddingTop: itemtiem.start_height * 0.8 + 5 + 'px', paddingBottom: itemtiem.end_height * 0.8 + 5 + 'px' }"
                                            v-for="itemtiem in getselect(data[item.day], itemday)"
                                            :rowspan="itemtiem.heightLenght > 0 ? itemtiem.heightLenght : 1"
                                            :colspan="getselect(data[item.day], itemday).length > 1 ? 1 : 2">

                                            <div class="box df aic jcsb">
                                                <div>
                                                    <div class="title mic-semblod" @click="handleLink(itemtiem)">
                                                        {{ itemtiem.ta_title }}
                                                        <span class="fs-14 c-7">
                                                        </span>
                                                    </div>
                                                    <div class="address" v-if="itemtiem.heightLenght >= 2">
                                                        {{ itemtiem.ddt_name }}
                                                    </div>
                                                </div>

                                                <template v-if="timestamp > itemtiem.ta_sign_start_time && timestamp < itemtiem.ta_sign_end_time ">
                                                  <div class="btn df fdc aic jcc"
                                                       :class="{ 'sign': itemtiem.is_signup == 10 }"
                                                       @click="handleSignUp(itemtiem)">

                                                    <template v-if="itemtiem.heightLenght > 0">
                                                      <template v-if="itemtiem.is_signup == 10">
                                                        <span>{{ $t('报名成功') }}</span>
                                                      </template>
                                                      <template v-else>
                                                        <span>{{ $t('一键报名') }}</span>
                                                      </template>
                                                    </template>

                                                    <template v-else>
                                                      <template v-if="itemtiem.is_signup == 10">
                                                        <span>{{ $t('报名成功') }}</span>
                                                      </template>
                                                      <template v-else>
                                                        <span>{{ $t('一键报名') }}</span>
                                                      </template>
                                                    </template>

                                                  </div>

                                                </template>
                                            </div>

                                        </td>
                                    </template>
                                </template>
                            </tr>

                        </template>

                        <!-- <tr class="scroll-container">
                            <td class="item-box" :style="{ minWidth: minWidth }" :rowspan="2">
                                <div class="box df aic jcsb">
                                    <div>
                                        <div class="title mic-semblod">OceanClub精英会员圆桌会议</div>
                                        <div class="address">成都</div>
                                    </div>

                                    <div class="btn df fdc aic jcc"><span>一键</span><span>报名</span></div>
                                </div>
                            </td>
                            <td class="item-box " :style="{ minWidth: minWidth }">
                                <div class="box df aic jcsb">
                                    <div>
                                        <div class="title mic-semblod">OceanClub精英会员圆桌会议</div>
                                    </div>

                                    <div class="btn df aic jcc"><span>报名</span></div>
                                </div>
                            </td>
                            <td class="item-box " :style="{ minWidth: minWidth }">
                                <div class="box df aic jcsb">
                                    <div>
                                        <div class="title mic-semblod">OceanClub精英会员圆桌会议</div>
                                    </div>

                                    <div class="btn df aic jcc"><span>报名</span></div>
                                </div>
                            </td>

                        </tr> -->



                    </tbody>

                </table>


            </div>



        </div>




    </div>
</template>

<script>
import { setSignUp } from "@api/active";
export default {
    props: {
        data: {
            type: Object,
            required: true
        },
    },
    mounted() {
        // 组件挂载后获取宽度
        const container = this.$refs.drag_container;
        const width = container.offsetWidth; // 或者使用 container.clientWidth
        this.minWidth = `${width / 2}px`;
        this.$refs.scrollableDiv.scrollTop = 432;
    },
    watch: {
        data: {

            handler(newValue, oldValue) {

                let arrs = [];
                let weekarr = ['周日', '周一', '周二', '周三', '周四', '周五', '周六'];
                let index = 0;
                for (let key in newValue) {

                    arrs.push({ day: key, week: weekarr[index] });
                    index++;
                }
                this.$nextTick(() => {
                    this.weeklist = arrs;

                })
                this.$refs.scrollableDiv.scrollTop = 432;
                this.dayData = 0;

            },
            deep: true, // 如果需要深度监听对象的变化，可以设置为 true
            immediate: true // 如果希望在组件创建时立即执行一次 handler，可以设置为 true
        }
    },
    methods: {

    },
    data() {
        return {
            timestamp: Date.now() / 1000,
            minWidth: '0px',
            // 每周的时间
            day1: ['00:00', '01:00', '02:00', '03:00', '04:00', '05:00', '06:00', '07:00', '08:00', '09:00', '10:00', '11:00', '12:00', '13:00', '14:00', '15:00', '16:00', '17:00', '18:00', '19:00', '20:00', '21:00', '22:00', '23:00'],

            weeklist: [],

            // 会议数据
            meetingData: [
                { date1: '4.00', date2: '7:00', title: 'OceanClub精英会员圆桌会议' },

            ],

            // 当前选中的日期
            dayData: 0,
            scrollArr: [432, 1584, 2736, 3888, 5040, 6192, 7344],


        };
    },

    created() {



    },
    methods: {

        // 跳转活动详情
        handleLink(item) {
            let str = '/cn';
            let Language = localStorage.getItem('currentLanguage');  //获取本地语言
            if (Language && Language != 'zh') {
                str = '/' + Language;
            }
            // this.$router.push(str + '/activity/info/' + item.ta_id); // 使用编程式导航跳转到 About 页面
            let target={}
            // 判断是否是精英赛
            if(item.ta_kind==30){
                target = this.$router.resolve(str + '/challenge/info/' + item.ta_id)
            }else{
                target = this.$router.resolve(str + '/activity/info/' + item.ta_id)
            }
            window.open(target.href, '_blank');
        },


        async handleSignUp(item) {
            let res = await setSignUp({ ta_id: item.ta_id });
            if (res.status == 200) {
                this.$message({
                    message: res.msg,
                    type: 'success'
                });
            }
        },



        handleWeek(index) {


            // 获取对应的滚动位置
            const targetScrollTop = this.scrollArr[index];
            // 使用 scrollTo 方法平滑滚动到对应的位置
            this.$refs.scrollableDiv.scrollTo({
                top: targetScrollTop,
                behavior: 'smooth' // 平滑滚动
            });
            // 更新 dayData
            this.dayData = index;

        },

        handleScroll() {
            let arr = [432, 1584, 2736, 3888, 5040, 6192, 7344];
            this.scrollTop = this.$refs.scrollableDiv.scrollTop;

            // 向下滚动
            if (this.dayData < arr.length - 1 && this.scrollTop >= arr[this.dayData + 1]) {
                this.dayData++;
            }
            // 向上滚动
            if (this.dayData > 0 && this.scrollTop < arr[this.dayData]) {
                this.dayData--;
            }
        },

        getselect(obj, time) {
            let arr = [];

            obj.forEach((item) => {
                let start_time = item.ta_start_time.split(' ')[1];
                let end_time = item.ta_end_time.split(' ')[1];
                // console.log(end_time.split(":")[0] - start_time.split(":")[0], ">>>><<<<")
                if (start_time.split(":")[0] == time.split(":")[0]) {
                    arr.push({ ...item, start_height: start_time.split(":")[1], end_height: end_time.split(":")[1], heightLenght: end_time.split(":")[0] - start_time.split(":")[0] })
                }


            });

            return arr;

        }
    }
};

</script>

<style lang="scss" scoped>
.weeklist {

    height: 40px;
    color: rgb(25, 25, 25);
    font-size: 14px;
    font-weight: 400;
    border-top: 1px solid #DFDFDF;

    span {
        line-height: 40px;
        text-align: center;
        display: inline-block;
        cursor: pointer;
    }

    span:hover {
        color: #B7251E;
    }

    .active {
        color: #B7251E;
    }
}

.drag-left {
    width: 56px;
    text-align: center;

    .drag-lefttext {
        height: 48px;

        span {
            position: relative;
            top: -13px;
            color: rgb(25, 25, 25);
            font-size: 14px;
        }
    }
}

.line-box {
    position: relative;
    height: 430px;
    overflow-y: scroll;

    &::-webkit-scrollbar {
        width: 0;
    }
}

.drag-left {
    position: absolute;
    left: 0;
}

.drag-container {

    width: calc(100% - 58px);
    // height: 100%;
    /* 设置容器高度 */
    overflow: hidden;
    /* 隐藏所有滚动条 */
    position: relative;
    left: 58px;

    /* 使子元素绝对定位相对于此容器 */
}

.scroll-container {
    width: 100%;
    // display: flex;
    /* 使用 flexbox 使内容横向排列 */
    height: 48px;
    /* 确保容器高度 */
    white-space: nowrap;
    /* 防止换行 */
    // border-bottom: 1px solid #DFDFDF;
    position: relative;
    border-top: 1px solid #ededed;

    .item-box {
        width: 100%;
        height: 48px;
        // min-width: 50%;
        // min-width: 627.5px;
        // background-color: antiquewhite;
        padding: 5px;
        position: relative;

        .box {
            width: 100%;
            height: 100%;
            border-radius: 4px;
            background: #F9EDEC;
            // position: relative;
            overflow: hidden;
            padding: 3px 6px 3px 21px;
            position: absolute;
            left: 0;
            top: 0;

            .title {
                color: rgb(25, 25, 25);
                line-height: 24px;
                font-size: 18px;
                cursor: pointer;

                &:hover {
                    color: #B7251E;
                }
            }

            .address {
                line-height: 24px;
                font-size: 16px;
                margin-top: 18px;
            }

            .btn {
                min-width: 58px;
                min-height: 24px;
                padding: 6px 9px;
                border-radius: 4px;
                color: rgb(183, 37, 30);
                font-size: 14px;
                background: #ffffff;
                box-shadow: 0px 0px 8px #ededed;

                &.sign {
                    background: rgb(255, 245, 245);
                }

                &:hover {
                    background: rgb(255, 245, 245);
                }
            }

            &::after {
                content: "";
                display: block;
                width: 4px;
                height: 100%;
                background: rgb(183, 37, 30);
                position: absolute;
                left: 0;
                top: 0;
            }
        }

    }

    // &::after {
    //     content: "";
    //     display: block;
    //     width: 100%;
    //     height: 1px;
    //     background-color: #DFDFDF;
    //     position: absolute;
    //     left: 0;
    //     bottom: 0;
    // }
}

.item {
    min-width: 100px;
    /* 确保每个项有最小宽度 */
    height: 48px;

    /* 水平居中 */
    /* 添加边框以便于查看 */
    margin-right: 10px;
    /* 项之间的间距 */
    cursor: grab;
    /* 默认光标样式 */
}
</style>